import { useEffect, useState } from 'react';
import {
    FormControl,
    Grid2 as Grid,
    InputLabel,
    MenuItem,
    Select,
    Typography
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CommonCard } from '../../component/cards/MainCard2';
import { SubmitButton } from '../../component/buttons';

import PersonalBodyCard from '../pages/UsersAdd/body/PersonalBodyCard';
import HeaderCard from '../pages/UsersAdd/HeaderUserAdd';
import { useClinics } from '../../hooks/useClinics';
import { useFormikEditClinicUser } from '../../hooks/useFormikAddUser';
import { fetchUser } from '../../services/users';
import ManagementHeader from './componets/ManagementHeader';

const EditClinicUser = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { state } = useLocation();
    const [userData, setUserData] = useState([]);

    const clinic = state?.clinic;
    const user = state?.user;
    const roleUuid = user?.role_uuid;

    useEffect(() => {
        if (!roleUuid) return;
        const fetchData = async () => {
            try {
                const [userResp] = await Promise.all([
                    fetchUser(roleUuid)
                ]);
                setUserData(userResp);
            } catch (error) {
                console.error('Erro ao procurar dados do paciente:', error);
            }
        };
        fetchData();
    }, [roleUuid]);

    const formik = useFormikEditClinicUser(userData, user, clinic);

    if (!user) {
        return null;
    }

    const handleCancel = () => {
        navigate('/mgmt/clinic/users', {
            state: { clinic }
        });
    };

    return (
        <CommonCard sx={{ m: 2, p: 2 }}>
            <ManagementHeader
                title={t('documentation.editUser')}
                subtitle={clinic?.name || t('clinics.selectClinic')}
                backTo={clinic ? '/mgmt/clinic/users' : '/mgmt/clinics'}
            />

            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    {/* Header */}
                    <Grid size={12}>
                        <HeaderCard
                            values={formik.values}
                            handleChange={formik.handleChange}
                            disableClinicSelect
                        />
                    </Grid>

                    {/* Personal data */}
                    <Grid size={12}>
                        <Typography variant="h6" gutterBottom>
                            {t('users.tabs.personalData')}
                        </Typography>

                        <PersonalBodyCard formik={formik} />
                    </Grid>

                    {/* Actions */}
                    <Grid
                        container
                        size={12}
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                            mt: 2
                        }}
                    >
                        <SubmitButton type="button" onClick={handleCancel}>
                            {t('common.cancel')}
                        </SubmitButton>

                        <SubmitButton
                            disabled={formik.isSubmitting}
                            name="submit"
                            type="submit"
                        >
                            {t('common.save')}
                        </SubmitButton>
                    </Grid>
                </Grid>
            </form>
        </CommonCard>
    );
};

export default EditClinicUser;
